import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { IonicModule } from '@ionic/angular'

import { AppPageRoutingModule } from './app-routing.module'

import { AppPage } from './app.page'
import { ComponentsModule } from 'src/app/components/components.module'
import { ToastModule } from 'primeng/toast'
import { ProgressBarModule } from 'primeng/progressbar'
import { MainPipeModule } from 'src/app/pipes/main-pipe.module'
import { FireRatingTypePipe } from 'src/app/pipes/fire-rating.pipe'
import { TooltipModule } from 'primeng/tooltip'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { FormsModule } from '@angular/forms'

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ComponentsModule,
    ProgressBarModule,
    AppPageRoutingModule,
    TooltipModule,
    MainPipeModule,
    FontAwesomeModule,
    ToggleSwitchModule,
    ToastModule,
  ],
  declarations: [AppPage],
  providers: [FireRatingTypePipe],
})
export class AppPageModule {}
